import { useEffect } from 'react';
import { Platform } from 'react-native';

import { useAttributionStore } from '@/stores/use-attribution-store';

import mixpanelService from '../clients/mixpanel';

export const useAttribution = () => {
  const { pid, c, firstOpenTracked, setAttribution, markTracked } =
    useAttributionStore();

  useEffect(() => {
    const handleWebAttribution = async () => {
      if (Platform.OS === 'web') {
        let newPid: string | undefined;
        let newC: string | undefined;

        const params = new URLSearchParams(window.location.search);
        newPid = params.get('pid') ?? undefined;
        newC = params.get('c') ?? undefined;

        if (newPid || newC) {
          setAttribution(newPid, newC);

          if (!firstOpenTracked) {
            const afParams: Record<string, string> = {};
            params.forEach((value, key) => {
              if (key.toLowerCase().startsWith('af_')) {
                afParams[key] = value;
              }
            });

            mixpanelService.track('Campaign Opened', {
              Pid: newPid,
              C: newC,
              ...afParams,
            });
            markTracked();
          }
        }
      }
    };

    handleWebAttribution();
  }, []);
};
